import request from '@/utils/request'

const JOURNAL_API = {
  publishList: 'periodical/list',
  createJournal: '/periodical/create',
  JournalDelete: '/periodical/delete',
  nextList: 'periodical-notice/list',
  nextUpdate: 'periodical-notice/update',
  JournalDetail: '/periodical/detail',
  JournalEdit: '/periodical/update',
  createNext: 'periodical-notice/create',
  periodical: 'periodical-notice/log',
  nextDelete: 'periodical-notice/delete',
  addLabel: '/periodical-label-map/create',
  deleteLabel: '/periodical-label-map/delete',
  updateLabel: '/periodical-label-map/update',
  labelSort: '/periodical-label-map/sort',
  contentCreate: '/periodical-content/create',
  contentBlong: '/periodical-content/belong',
  battchBlong: '/periodical-content/batch-belong',
  battchDelete: '/periodical-content/batch-delete',
  contenetDelete: '/periodical-content/delete',
  contentSort: '/periodical-content/sort',
  contentEdit: '/periodical-content/update'
}

// 发布列表
export function publishList (params) {
  return request({
    url: JOURNAL_API.publishList,
    method: 'get',
    params
  })
}
// 期刊创建
export function createJournal (data) {
  return request({
    url: JOURNAL_API.createJournal,
    method: 'post',
    data
  })
}

/**
 *
 * @param {id} 电子期刊id
 * @param {title} 电子期刊标题
 * @param {subtitle} 电子期刊描述
 * @param {cover} 电子期刊封面
 * @param {issue_time} 电子期刊发布时间
 */
export function JournalEdit (data) {
  return request({
    url: `${JOURNAL_API.JournalEdit}`,
    method: 'post',
    data
  })
}

/**
 * @desc 获取电子期刊详情
 * @param {id} 电子期刊id
 */
export function JournalDetail (id) {
  return request({
    url: `${JOURNAL_API.JournalDetail}?id=${id}`,
    method: 'get',
  })
}
/**
 * @desc 添加期刊内容
 * @param {periodical_id} 电子期刊id
 * @param {periodical_label_map_id} 标签id
 * @param {pic_url} 图片地址
 */
export function contentCreate (data) {
  return request({
    url: `${JOURNAL_API.contentCreate}`,
    method: 'post',
    data
  })
}
/**
 * @desc 删除期刊内容
 * @param {id} 内容id
 */
export function contenetDelete (data) {
  return request({
    url: `${JOURNAL_API.contenetDelete}`,
    method: 'post',
    data
  })
}
/**
 * @desc 批量删除期刊内容
 * @param {ids} 内容id数组
 */
export function battchDelete (data) {
  return request({
    url: `${JOURNAL_API.battchDelete}`,
    method: 'post',
    data
  })
}

/**
 * @desc 批量修改归属
 * @param {ids} 内容id数组
 * @param {periodical_label_map_id} 标签id
 */
export function battchBlong (data) {
  return request({
    url: JOURNAL_API.battchBlong,
    method: 'post',
    data
  })
}
/**
 * @desc 修改归属
 * @param {id} 内容id
 * @param {periodical_label_map_id} 标签id
 */
export function contentBlong (data) {
  return request({
    url: JOURNAL_API.contentBlong,
    method: 'post',
    data
  })
}
/**
 * @desc 内容编辑，替换图片
 * @param {id} 需要替换的内容id
 * @param {pic_url} 需要替换的url
 */
export function contentEdit (data) {
  return request({
    url: JOURNAL_API.contentEdit,
    method: 'post',
    data
  })
}

// 期刊删除
export function JournalDelete (data) {
  return request({
    url: JOURNAL_API.JournalDelete,
    method: 'post',
    data
  })
}
// 预告编辑
export function nextUpdate (data) {
  return request({
    url: JOURNAL_API.nextUpdate,
    method: 'post',
    data
  })
}
// 预告列表
export function nextList (params) {
  return request({
    url: JOURNAL_API.nextList,
    method: 'get',
    params
  })
}
// 预告创建
export function createNext (data) {
  return request({
    url: JOURNAL_API.createNext,
    method: 'post',
    data
  })
}
// 预告删除
export function nextDelete (data) {
  return request({
    url: JOURNAL_API.nextDelete,
    method: 'post',
    data
  })
}
// 预告日志
export function periodical (params) {
  return request({
    url: JOURNAL_API.periodical,
    method: 'get',
    params
  })
}
/**
 * @desc 新增标签
 * @param {name} 标签名
 * @param {periodical_id} 期刊id
 */
export function addLabel (data) {
  return request({
    url: JOURNAL_API.addLabel,
    method: 'post',
    data
  })
}
/**
 * @desc 删除标签
 * @param {id} 删除标签的id
 */
export function deleteLabel (data) {
  return request({
    url: JOURNAL_API.deleteLabel,
    method: 'post',
    data
  })
}
/**
 * @desc 编辑标签
 * @param {id} 标签id
 * @param {name} 标签名
 */
export function updateLabel (data) {
  return request({
    url: JOURNAL_API.updateLabel,
    method: 'post',
    data
  })
}
/**
 * @desc 标签排序
 * @param {id} 需要替换标签id
 * @param {sortedId} 需要被替换id
 */
export function labelSort (data, sortedId) {
  return request({
    url: `${JOURNAL_API.labelSort}?id=${sortedId}`,
    method: 'post',
    data
  })
}
/**
 * @desc 内容排序
 * @param {id} 需要替换内容id
 * @param {sortedId} 需要被替换id
 */
export function contentSort (data, sortedId) {
  return request({
    url: `${JOURNAL_API.contentSort}?id=${sortedId}`,
    method: 'post',
    data
  })
}
export default {
  publishList,
  nextList,
  JournalDetail,
  JournalEdit,
  periodical,
  JournalDelete,
  nextDelete,
  addLabel,
  deleteLabel,
  updateLabel,
  labelSort,
  contentCreate,
  contenetDelete,
  battchDelete,
  contentBlong,
  battchBlong,
  contentSort,
  contentEdit,
  nextUpdate,
}
